import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Henter på nytt bare spørringene for de nevnte ressursene.
 *
 * Erstatter ra-cores `refresh()`, som invaliderer ALLE spørringer i appen —
 * også kundepanelet, oversikten og alt annet som står på skjermen — etter en
 * endring som bare berører én eller to ressurser.
 */
export const useInvalidate = () => {
  const queryClient = useQueryClient();
  return useCallback(
    (...resources: string[]) =>
      Promise.all(
        resources.map((resource) =>
          queryClient.invalidateQueries({ queryKey: [resource] }),
        ),
      ),
    [queryClient],
  );
};
